// extracted by mini-css-extract-plugin
export default {"tile":"QRTile_tile__z4kMs","skeleton":"QRTile_skeleton__Ewcna","qr-tile-skeleton-loading":"QRTile_qr-tile-skeleton-loading__uiGMz","error":"QRTile_error__C590d"};